export const MAX_SOURCE_UPLOAD_BYTES = 8 * 1024 * 1024;
export const MAX_CARD_STILL_BYTES = 750 * 1024;
export const MAX_BANNER_OUTPUT_BYTES = 1500 * 1024;
export const BANNER_CROP_OUTPUT_PX = 1024;
export const CARD_CROP_OUTPUT_WIDTH = 336;
export const CARD_CROP_OUTPUT_HEIGHT = 432;
export const SOURCE_MAX_MB = MAX_SOURCE_UPLOAD_BYTES / (1024 * 1024);
export const CARD_STILL_MAX_KB = MAX_CARD_STILL_BYTES / 1024;
export const BANNER_OUTPUT_MAX_KB = MAX_BANNER_OUTPUT_BYTES / 1024;

export const ALLOWED_BANNER_UPLOAD_TYPES = Object.freeze([
    'image/webp',
    'image/jpeg',
    'image/jpg',
    'image/png'
]);

export const ALLOWED_CARD_IMAGE_TYPES = ALLOWED_BANNER_UPLOAD_TYPES;

export const ALLOWED_CARD_GIF_TYPES = Object.freeze(['image/gif']);

export const ALLOWED_CARD_VIDEO_TYPES = Object.freeze([
    'video/webm',
    'video/mp4'
]);

export const isAllowedBannerUploadType = (mimeType) => {
    if (typeof mimeType !== 'string') return false;
    return ALLOWED_BANNER_UPLOAD_TYPES.includes(mimeType.trim().toLowerCase());
};

export const isAllowedCardImageType = (mimeType) => isAllowedBannerUploadType(mimeType);

export const isAllowedCardGifType = (mimeType) => {
    if (typeof mimeType !== 'string') return false;
    return ALLOWED_CARD_GIF_TYPES.includes(mimeType.trim().toLowerCase());
};

export const isAllowedCardVideoType = (mimeType) => {
    if (typeof mimeType !== 'string') return false;
    return ALLOWED_CARD_VIDEO_TYPES.includes(mimeType.trim().toLowerCase());
};

export const getDataUrlDecodedByteLength = (dataUrl) => {
    if (typeof dataUrl !== 'string') return 0;
    const comma = dataUrl.indexOf(',');
    if (comma < 0) return 0;
    const b64 = dataUrl.slice(comma + 1);
    if (!b64) return 0;
    const padding = b64.endsWith('==') ? 2 : b64.endsWith('=') ? 1 : 0;
    return Math.max(0, Math.floor((b64.length * 3) / 4) - padding);
};

export const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(blob);
});

export const captureVideoPosterDataUrl = (videoEl, outputWidth, outputHeight) => {
    const canvas = document.createElement('canvas');
    canvas.width = outputWidth;
    canvas.height = outputHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas is not available');
    const vw = videoEl.videoWidth;
    const vh = videoEl.videoHeight;
    if (!vw || !vh) throw new Error('Invalid video');
    const cover = Math.max(outputWidth / vw, outputHeight / vh);
    const dw = vw * cover;
    const dh = vh * cover;
    const dx = (outputWidth - dw) / 2;
    const dy = (outputHeight - dh) / 2;
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(videoEl, dx, dy, dw, dh);
    return canvas.toDataURL('image/webp', 0.9);
};

export const captureImagePosterDataUrl = (imageEl, outputWidth, outputHeight) => {
    const canvas = document.createElement('canvas');
    canvas.width = outputWidth;
    canvas.height = outputHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas is not available');
    const iw = imageEl.naturalWidth;
    const ih = imageEl.naturalHeight;
    if (!iw || !ih) throw new Error('Invalid image');
    const cover = Math.max(outputWidth / iw, outputHeight / ih);
    const dw = iw * cover;
    const dh = ih * cover;
    const dx = (outputWidth - dw) / 2;
    const dy = (outputHeight - dh) / 2;
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(imageEl, dx, dy, dw, dh);
    return canvas.toDataURL('image/webp', 0.9);
};
